import Api from '../index';

const MenuApi = {

	getFullMenu() {
		return Api.getPromise('/menu/');
	},

	updateUrunMevcut(pk: number) {
		return Api.putPromise('/menu/urunmevcutguncelle/', {pk});
	},

	getMenuKategorileri() {
		return Api.getPromise('/menu/kategoriler/');
	},

	getKategoriSayfalari(id: number) {
		return Api.getPromise('/menu/kategorisayfalar/' + id + '/');
	},

	getUrunler(id: number) {
		return Api.getPromise('/menu/sayfaurunler/' + id + '/');
	},

	getKampanyalar() {
		return Api.getPromise('/menu/kampanyalar/');
	},

	getEtkinlikler() {
		return Api.getPromise('/menu/etkinlikler/');
	},

	topluGuncelle(data: any) {
		return Api.postPromise('/menu/toplu-guncelle/', data);
	},

	// YÖNETİM API'LERİ
	kategori: {
		list() {
			return Api.getPromise('/menu/yonetim/kategori-yonetim/');
		},
		create(data: any) {
			return Api.postPromise('/menu/yonetim/kategori-yonetim/', data);
		},
		update(id: number, data: any) {
			return Api.putPromise(`/menu/yonetim/kategori-yonetim/${id}/`, data);
		},
		delete(id: number) {
			return Api.deletePromise(`/menu/yonetim/kategori-yonetim/${id}/`, {});
		}
	},
	sayfa: {
		list() {
			return Api.getPromise('/menu/yonetim/sayfa-yonetim/');
		},
		create(data: any) {
			return Api.postPromise('/menu/yonetim/sayfa-yonetim/', data);
		},
		update(id: number, data: any) {
			return Api.putPromise(`/menu/yonetim/sayfa-yonetim/${id}/`, data);
		},
		delete(id: number) {
			return Api.deletePromise(`/menu/yonetim/sayfa-yonetim/${id}/`, {});
		}
	},
	urun: {
		list() {
			return Api.getPromise('/menu/yonetim/urun-yonetim/');
		},
		create(data: any) {
			return Api.postPromise('/menu/yonetim/urun-yonetim/', data);
		},
		update(id: number, data: any) {
			return Api.putPromise(`/menu/yonetim/urun-yonetim/${id}/`, data);
		},
		delete(id: number) {
			return Api.deletePromise(`/menu/yonetim/urun-yonetim/${id}/`, {});
		}
	},
	kampanya: {
		list() {
			return Api.getPromise('/menu/yonetim/kampanya-yonetim/');
		},
		create(data: any) {
			return Api.postPromise('/menu/yonetim/kampanya-yonetim/', data);
		},
		update(id: number, data: any) {
			return Api.putPromise(`/menu/yonetim/kampanya-yonetim/${id}/`, data);
		},
		updatePartial(id: number, data: any) {
			return Api.patchPromise(`/menu/yonetim/kampanya-yonetim/${id}/`, data);
		},
		delete(id: number) {
			return Api.deletePromise(`/menu/yonetim/kampanya-yonetim/${id}/`, {});
		}
	}
};

export default MenuApi;
